<div class="panel-header d-flex align-items-center flex-shrink-0 px-2 gap-1">
  <div class="d-flex flex-column flex-fill overflow-hidden py-1">
    <span class="mat-font-title-sm text-truncate">{{ title() }}</span>
    @if (subtitle()) {
      <span class="mat-font-label-sm mat-text-on-surface-variant text-truncate">{{ subtitle() }}</span>
    }
  </div>

  <ng-content select="[panelHeaderActions]" />

  <button
    matIconButton
    (click)="toggleFullscreen()"
    [attr.aria-label]="isFullscreen() ? 'Salir de pantalla completa' : 'Pantalla completa'"
  >
    <mat-icon>{{ isFullscreen() ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
  </button>

  <button
    matIconButton
    (click)="toggleCollapsed()"
    [attr.aria-label]="isCollapsed() ? 'Expandir panel' : 'Contraer panel'"
  >
    <mat-icon>{{ isCollapsed() ? 'expand_less' : 'expand_more' }}</mat-icon>
  </button>

  <button matIconButton (click)="close()" aria-label="Cerrar panel">
    <mat-icon>close</mat-icon>
  </button>
</div>

@if (!isCollapsed()) {
  <mat-divider />
  <div class="flex-fill overflow-hidden">
    <ng-content />
  </div>
}
